/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventVisibility = "DRAFT" | "PRIVATE" | "PUBLIC" | "%future added value";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type EventCard_event = {
    readonly id: string;
    readonly rowId: string;
    readonly name: string;
    readonly slug: string;
    readonly prettyUrl: string;
    readonly startAt: string;
    readonly endAt: string;
    readonly timeZone: string;
    readonly myAttendance: {
        readonly id: string;
    } | null;
    readonly visibility: EventVisibility;
    readonly owner: {
        readonly __typename: string;
        readonly isMe?: boolean | null | undefined;
        readonly myMembership?: {
            readonly membershipLevel: GuildMembershipLevel;
        } | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"ActorItem_actor">;
    } | null;
    readonly eventCardHasPresentations: {
        readonly totalCount: number;
    };
    readonly coverPhoto: {
        readonly " $fragmentRefs": FragmentRefs<"GraphQLImage_image">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AttendEventButton_event" | "EventCardPresentationsSection_event" | "EventCardAttendeesSection_event">;
    readonly " $refType": "EventCard_event";
};
export type EventCard_event$data = EventCard_event;
export type EventCard_event$key = {
    readonly " $data"?: EventCard_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventCard_event">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCard_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActorItem_actor"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMe",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "membershipLevel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "eventCardHasPresentations",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_ASC",
            "ID_ASC"
          ]
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "presentations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "presentations(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GraphQLImage_image"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AttendEventButton_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventCardPresentationsSection_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventCardAttendeesSection_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();
(node as any).hash = 'b557d98988f42730e9c8b9ee3773ef1e';
export default node;
